export default {
    planEditors: {
        list: [],
        new: { planFirms: [], availableRoles: [] },
        edit: { planEditor: {}, planFirms: [], availableRoles: [] }
    }
};
